import { Icon } from '@platform/components';
import { useEffect, useState } from 'react';

const BackToTopCta = ({ enabled }: { enabled?: boolean }) => {
  const [topElement, setTopElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTopElement(document.getElementById('root-scroll'));
  }, []);

  const scrolltoTop = () => {
    if (!topElement) {
      return;
    }

    topElement.scrollTop = 0;
  };

  if (!enabled) {
    return null;
  }

  return (
    <div className='w-fit ml-auto sm:absolute right-6'>
      <a onClick={scrolltoTop} className='cursor-pointer w-fit flex gap-2 text-md blue-link'>
        Back to top
        <Icon type='chevron-up' />
      </a>
    </div>
  );
};

export default BackToTopCta;
